import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
// components
import Button from 'components/UI/CustomButtons/Button';
import CustomInput from 'components/UI/CustomInput/CustomInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import Loading, { LoadingAnimation } from 'components/common/Loading';
import Snackbars from 'components/UI/Snackbar/Snackbar';
// styles
import Card from 'components/UI/Card/Card';
import CardBody from 'components/UI/Card/CardBody';
import withStyles from '@material-ui/core/styles/withStyles';
import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles';
// icons
import Trash from '@material-ui/icons/Delete';
import WithPermission from 'components/User/WithPermission';

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newNote: '',
    };
  }

  Row = ({ data }) => {
    const { classes, t, removeNote, isRemovingNote } = this.props;

    return (
      <li style={{ position: 'relative' }}>
        {isRemovingNote && <Loading show />}
        <div
          className={`${classes.verticalAlignment} ${classes.noteItem}`}
          style={{ position: 'relative' }}
        >
          <div>
            <b>{data.description}</b>
            <div className={classes.descriptionNotes}>
              {t('ad.notes.date', {
                date: moment(data.createdOn).format('hh:mm a - D MMMM Y'),
                author: data.creator,
              })}
            </div>
          </div>
          <WithPermission
            alt={null}
            allowPermissions={['delete_note', 'delete_ownership_note']}
          >
            <Button
              data-cy="clear-btn"
              color="danger"
              simple
              round
              justIcon
              id="clear-btn"
              onClick={() => removeNote(data.id)}
            >
              <Trash />
            </Button>
          </WithPermission>
        </div>
      </li>
    );
  };

  render() {
    const {
      data,
      t,
      isSaving,
      addNote,
      classes,
      errors,
      showNotification,
      closeNotification,
    } = this.props;
    const { newNote } = this.state;

    return (
      <React.Fragment>
        <Snackbars
          place="tc"
          message={errors.length > 0 ? errors[0].messages[0] : ''}
          open={showNotification}
          color="danger"
          closeNotification={() => closeNotification()}
          close
        />

        <Card>
          <CardBody>
            <WithPermission alt={null} allowPermissions={['add_note']}>
              <form
                onSubmit={evt => {
                  evt.preventDefault();
                  addNote(newNote);
                  this.setState({ newNote: '' });
                }}
              >
                <CustomInput
                  id="new_note"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!isSaving ? (
                          <Button
                            data-cy="add-btn"
                            color="success"
                            simple
                            id="add-btn"
                            disabled={newNote === ''}
                            style={{ padding: 0 }}
                            type="submit"
                          >
                            {t('ad.notes.add')}
                          </Button>
                        ) : (
                          <LoadingAnimation />
                        )}
                      </InputAdornment>
                    ),
                    value: newNote,
                    onChange: e => this.setState({ newNote: e.target.value }),
                    placeholder: t('ad.notes.placeholder'),
                  }}
                />
              </form>
            </WithPermission>

            <WithPermission
              alt={<h4>{t('ad.notes.no_permissions')}</h4>}
              allowPermissions={['list_note']}
            >
              {data && data.length > 0 ? (
                <ul className={classes.listOfNotes}>
                  {data.map(note => (
                    <this.Row key={note.id} data={note} />
                  ))}
                </ul>
              ) : (
                <h4 className={classes.emptyNotes}>{t('ad.notes.empty')}</h4>
              )}
            </WithPermission>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

Notes.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  isSaving: PropTypes.bool.isRequired,
  isRemovingNote: PropTypes.bool.isRequired,
  addNote: PropTypes.func.isRequired,
  removeNote: PropTypes.func.isRequired,
  errors: PropTypes.instanceOf(Object).isRequired,
  showNotification: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(userProfileStyles)(Notes));
